import { getLocale } from '@/utils/locales';

type LanguageMap =
    | {
          [key: string]: any;
      }
    | undefined;

export const getLocalizedContent = (field: any, lang: string, test?: any): any => {
    const locale = getLocale(lang);

    if (!field) {
        return;
    }

    // return field['en'];
    return field[locale] || field['en'];
};
